import { headerApiService } from "@/src/lib/api-services/headerApiServices";
import { useState } from "react";
import Image from "next/image";
import Progressbar from "../loading";

import { showOtpToast, useToast } from "@/src/lib/hooks/useToast";
import { useRouter } from "next/router";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import CustomButton from "@/src/lib/ui/Button";
import CustomCheckbox from "@/src/lib/ui/customCheckbox";
import TextField from "@/src/components/custom-fields/TextField";

const SendOtp = ({
    setOtp,
    setMobileNumber,
    mobileNumber,
    isAddPatientWithAnotherNumber,
    title,
}) => {
    const router = useRouter();
    const { showCustomToast } = useToast();
    const [isChecked, setIsChecked] = useState(
        isAddPatientWithAnotherNumber ? true : true
    );

    const onMobileNumberChange = (e) => {
        setMobileNumber(e.target.value);
    };

    const mutation = useHODMutation(headerApiService.getOtp, {
        onSuccess: (data) => {
            setOtp(data?.data?.requestId);
            if (data?.data?.otp && data?.data?.otp !== "XXXXXX") {
                showOtpToast(`Your Otp is - ${data?.data?.otp}`);
            } else {
                showCustomToast(data?.message, "success");
            }
        },
        onError: (error) => {
            showCustomToast(error.response.data.message, "error");
        },
    });

    const otpHandler = () => {
        if (!mobileNumber.trim()) {
            showCustomToast("Please Enter Mobile Number", "error");
            return;
        }

        if (mobileNumber.length !== 10) {
            showCustomToast("Please Enter 10 Digit Mobile Number", "error");
            return;
        }

        mutation.mutate({ mobileNo: mobileNumber });
    };

    const label = { inputProps: { "aria-label": "Checkbox demo" } };

    const handlePrivacyPolicyClick = () => {
        router.push("/pages/privacy-policy");
    };

    const handleTermsAndConditionsClick = () => {
        router.push("/pages/terms-of-use");
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            otpHandler();
        }
    };

    return (
        <>
            <div className="md:mb-6 mb:3">
                <h5 className="font-bold md:text-2xl text-xl">{title}</h5>
                <h6 className="text-sm font-medium">
                    An OTP will be sent to your mobile number.
                </h6>
            </div>

            <TextField
                fullWidth
                placeholder="Please Enter 10 Digit Mobile Number"
                value={mobileNumber}
                onChange={(e) => onMobileNumberChange(e)}
                onKeyDown={handleKeyDown}
                startIcon={
                    <div className="flex flex-row items-center gap-1">
                        <Image
                            src="/images/flag.png"
                            alt="India Flag"
                            width={20}
                            height={20}
                        />
                        <p>+91</p>
                    </div>
                }
            />

            {!isAddPatientWithAnotherNumber && (
                <div className="flex flex-row items-center my-3 gap-4">
                    <CustomCheckbox
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                    />

                    <p className="text-sm md:py-3 py-1">
                        I agree to the
                        <span
                            className="text-primary font-medium cursor-pointer"
                            onClick={handleTermsAndConditionsClick}
                        >
                            {" "}
                            Terms & Conditions
                        </span>{" "}
                        &{" "}
                        <span
                            className="text-primary font-medium cursor-pointer"
                            onClick={handlePrivacyPolicyClick}
                        >
                            privacy policy
                        </span>
                    </p>
                </div>
            )}

            <CustomButton
                onClick={otpHandler}
                variant="contained"
                size="large"
                fullWidth
                disabled={!isChecked || mutation.isLoading}
                className={`flex items-center justify-center ${
                    !isAddPatientWithAnotherNumber ? "" : "mt-4"
                }`}
            >
                {mutation.isLoading && (
                    <div className="mr-1">
                        <Progressbar size={20} />
                    </div>
                )}
                <p className="text-white"> Get OTP </p>
            </CustomButton>
        </>
    );
};
export default SendOtp;
